const envBaseUrl = (process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");
const productionBaseUrl = "https://api.globemet.com";
const runtimeOrigin =
  typeof window !== "undefined" ? window.location.origin.replace(/\/$/, "") : "";
const runtimeHost = typeof window !== "undefined" ? window.location.hostname : "";
const localBaseUrl =
  runtimeHost === "localhost" || runtimeHost === "127.0.0.1" ? runtimeOrigin : "";
const normalizedBaseUrl = envBaseUrl || localBaseUrl || productionBaseUrl;
const normalizedApiUrl = normalizedBaseUrl.endsWith("/api")
  ? normalizedBaseUrl
  : `${normalizedBaseUrl}/api`;

export const API_BASE_URL = normalizedBaseUrl;
export const API_URL = normalizedApiUrl;

export const buildApiUrl = (path = "") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_URL}${normalizedPath}`;
};
